import React from 'react';

const NotFound = () => {
  return (
    <article className="text-2xl flex flex-wrap justify-center items-start m-10 mb-4">
      <h1>Gözleg Tapylmady...</h1>
    </article>
  );
};

export default NotFound;
